var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-star-component",on:{"click":function($event){$event.stopPropagation();return _vm.toggleFavorite.apply(null, arguments)}}},[_c('font-awesome-icon',{class:{ favorite: _vm.isFavorite, 'not-favorite': !_vm.isFavorite },attrs:{"icon":"fa-duotone fa-solid fa-star"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }